export default __webpack_public_path__ + "static/media/living-sk-logo-dark-bg.3171a989.svg";